interface Props {
  activeColor: string;
}
const ChatIcon = (props: Props) => {
  const activeColor = props.activeColor ? props.activeColor : "#234cfc";
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 10C15.7 10 9 15.6 9 22.5C9 25.9 10.8 29 13.8 31.1C13.5 32.6 12.8 34.2 11.5 35.5C14.3 35.1 16.6 34.3 18.5 33.2C20.2 33.7 22.1 34 24 34C32.3 34 39 28.4 39 22.5C39 15.6 32.3 10 24 10Z"
        stroke="#234cfc"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ChatIcon;
